/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Passwordmismatch1Inputs */

const zh_auth_passwordmismatch1 = /** @type {(inputs: Auth_Passwordmismatch1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两次密码输入不一致`)
};

const en_auth_passwordmismatch1 = /** @type {(inputs: Auth_Passwordmismatch1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwords do not match`)
};

const es_auth_passwordmismatch1 = /** @type {(inputs: Auth_Passwordmismatch1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las contraseñas no coinciden`)
};

/**
* | output |
* | --- |
* | "Passwords do not match" |
*
* @param {Auth_Passwordmismatch1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_passwordmismatch1 = /** @type {((inputs?: Auth_Passwordmismatch1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Passwordmismatch1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_passwordmismatch1(inputs)
	if (locale === "en") return en_auth_passwordmismatch1(inputs)
	return es_auth_passwordmismatch1(inputs)
});
export { auth_passwordmismatch1 as "auth_passwordMismatch" }